import { fontSize, fontStyle, fontWeight, lineHeight, fontFamily } from './typography/index.js';
import { borderRadiusTokens } from './borderRadius/values.js';
import { spacingTokens } from './spacing/values.js';
import { motionTokens } from './motion/values.js';

var defaultTheme = {
  fontSize: fontSize,
  fontStyle: fontStyle,
  fontWeight: fontWeight,
  lineHeight: lineHeight,
  fontFamily: fontFamily,
  borderRadius: borderRadiusTokens,
  spacing: spacingTokens,
  motion: motionTokens
};

export { defaultTheme };
